import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REF_TYPES } from 'components/editor/FootnoteMenu/constants';
import {Schema} from "plugins/citations";
import stringify from 'json-stable-stringify';
// import { refId } from '.';

export const refId = (ref) => {
    return stringify(ref.requiredForm);
}

interface FootnotesState {
    references: any,
    isExtern: boolean,
    referencesId: any
}


const initialState: FootnotesState = {
    references: Object.fromEntries(Schema.getItemTypes().map(type => [type.value, {}])),
    isExtern: false,
    referencesId: {}
}

const footnotesSlice = createSlice({
    name: 'footnotes',
    initialState,
    reducers: {
        referencesAdd: (state, action: PayloadAction<any>) => {
            const ref = action.payload.ref;
            const refType = action.payload.refType;
            const doi = action.payload.doi;

            const referenceId = refId(ref);
            if (!referenceId) {
                return;
            }
            state.referencesId[referenceId] = 1;
            state.references[refType][doi] = { ...ref, id: doi };
        },
        referencesDelete: (state, action: PayloadAction<any>) => {
            const clusterId = action.payload.clusterId;
            const id = action.payload.id;
            delete state.referencesId[id];
            for (const refType of Object.keys(state.references)) {
                for (const doi of Object.keys(state.references[refType])) {
                    if (doi == clusterId) {
                        delete state.references[refType][doi];
                    }
                }
            }
        },
        referencesReset: (state) => {
            state.referencesId = {};
            for (const refType of Object.keys(state.references)) {
                for (const doi of Object.keys(state.references[refType])) {
                    delete state.references[refType][doi];
                }
            }
        },
        footnotesSetExtern: (state, action: PayloadAction<boolean>) => {
            state.isExtern = action.payload;
        }
    }
})

export const { referencesAdd, referencesReset, footnotesSetExtern, referencesDelete } = footnotesSlice.actions;

export default footnotesSlice.reducer;